
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reiki",
      function () {
        return require("private-next-pages/reiki/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reiki"])
      });
    }
  